<template>
  <div v-if="measurements" class="measurement-list-wrapper">
    <div :class="`measurements ${customClass}`">
      <PopoverMeasurement
        v-for="measurement in measurements"
        :key="measurement.label"
        :reading="measurement.reading"
        :label="measurement.label"
        :unitsLabel="measurement.unitsLabel"
        :imageSrc="measurement.imageSrc"
        :showInactiveReading="measurement.showInactiveReading"
        :customClass="measurement.customClass"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import PopoverMeasurement from '../popoverMeasurement.vue'
import type { PopoverMeasurementDataResult } from '@/helpers/widgets/helper'

export default defineComponent({
  name: 'MeasurementList',
  components: {
    PopoverMeasurement
  },
  props: {
    measurements: Array as PropType<PopoverMeasurementDataResult[]>,
    customClass: String
  }
})
</script>

<style lang="scss" scoped>
.measurement-list-wrapper {
  display: flex;
  justify-content: center;

  .measurements {
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: space-between;

    :deep(.measurement) {
      width: 100%;
      max-width: 93px;
      margin: 0 4%;
    }
  }
}
</style>
